import React, { useState, useEffect } from "react";
import "./ViewPlans.css";
import Navbar from "../Layouts/Navbar/Navbar";
import ProductSelection from "../Pages/Product-Container/Select-Product/ProductSelection";
import Button from "../InputField/Button/Button";
import user from "../../Assets/Images/user.svg";
import CarDetails from "../Pages/Product-Container/Selected-Product-Container/Car-Details/CarDetails";
import EditVehicleDetails from "../Pages/Edit-Inputs-Container/Edit-Vehicle-Details/EditVehicleDetails";
import EditPersonalDetails from "../Pages/Edit-Inputs-Container/Edit-Personal-Details/EditPersonalDetails";
import DownloadPolicy from "../Pages/Download-Policy/DownloadPolicy";
import EditAddressDetails from "../Pages/Edit-Inputs-Container/Edit-Address-Details/EditAddressDetails";
import { useDispatch, useSelector } from "react-redux";
import { fetchMmvAction } from "../../Redux/Actions/fetchMmvAction";
import { resetVehicleData } from "../../Redux/Reducers/MmvReducer";
import Loader from "../Layouts/Loader/Loader";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import PaymentConfirmation from "../Pages/Payment-Confirmation/PaymentConfirmation";
import { purchaseAction } from "../../Redux/Actions/purchaseAction";
import { getWalletBalance } from "../../Redux/Actions/fetchWalletBalance";
import { fetchUserDetailsAction } from "../../Redux/Actions/getUserDetails";
import VehicleType from "../Pages/Vehicle-Type/VehicleType";
import { fectchEngineValidaionAction } from "../../Redux/Actions/fetchClientDetails";
import ButtonLoader from "../Layouts/Loader/Button Loader/ButtonLoader";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

Modal.setAppElement("#root");

const ViewPlans = () => {
  // ProductSelection, downloadPolicy, carDetails, editCarDetails, editAdressDetails
  const [RenderComponent, setRenderComponent] = useState("ProductSelection");
  const [CallForEdit, setCallForEdit] = useState(false);
  const [isButtonLoader, setisButtonLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [chekEngineLodar, setCheckEngineLoader] = useState(false)

  // modal functions:
  const [modalIsOpen, setIsOpen] = useState(false);

  // getUserToken
  const userToken = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.loginData;
  });
  const RsaOnly = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.loginData?.is_hide_master_policy;

  });
 


  const getLoggedInStatus = useSelector((data) => {
    return data?.getLoggedInStatus
  })
  let pdfReaderData = useSelector((data) => {
    return data?.pdfReaderData
  })

  // get purchase response
  const getPurchaseDetails = useSelector((state) => {
    return state?.getPurchaseDetails;
  });
  // navigation  
  const navigate = useNavigate();

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const loading = useSelector((state) => {
    return state?.getMmvDetails?.isLoading;
  });

  const vehicleDetails = useSelector((state) => {
    return state?.getMmvDetails?.data?.data;
  });

  let modelDetails = vehicleDetails ? vehicleDetails?.model_details[0] : null;

  const [FormData, setFormData] = useState({
    productName: null,
    productId: null,
    vehicleNumber: null,
    businessType: null,
    companyName: null,
    make: modelDetails?.Brand ? modelDetails?.Brand : null,
    model: null,
    firstName: null,
    lastName: null,
    mobileNumber: null,
    emailId: null,
    pincode: null,
    policyBuyPrice: null,
    policyNumber: null,
    policyStartDate: null,
    nomineeName: RsaOnly ? "RSA_Only" : null,
    nomineeRelation: RsaOnly ? "RSA_Only" : null,
    masterPolicyNumber: null,
    engineNumber: null,
    chassisNumber: null,
    addressLineOne: null,
    addressLineTwo: null,
    state: null,
    city: null,
    nomineeAge: null,
    vehicleType: null,
    cc: null,
    isCompleteCareChecked: false,
    isManipalCheck: true,
    dob: null,
    gender: null,
    crossRoad: true,
    gstNumber: null,
    portalId: userToken?.portalId || 1,
    defaultCCPlanAmount: 0,
    tenure: 1,
    tenurePa: 1,
    ambulanceCover:true
  });


  useEffect(() => {
    setFormData((prevItems) => ({
      ...prevItems,
      make: modelDetails?.Brand ? modelDetails?.Brand : FormData?.make,
      model: modelDetails?.Model ? modelDetails?.Model : FormData?.model,
    }));
  }, [vehicleDetails]);
 
  const dispatch = useDispatch();
  if (FormData.vehicleNumber !== null) {
    FormData.vehicleNumber = FormData.vehicleNumber.toUpperCase();
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [RenderComponent]);

  const [isGstOpt, setIsGstOpt] = useState(0)
  const [isUserDefaultCcPlanAmt, setIsUserDefaultCcPlanAmt] = useState(0)

  useEffect(() => {
    const fetchuser = async () => {
      let userDetails = await dispatch(fetchUserDetailsAction(userToken?.token));
      if (userDetails?.payload?.status === 1) {
        setIsGstOpt(userDetails?.payload?.data?.is_opt_gst)
        setIsUserDefaultCcPlanAmt(userDetails?.payload?.data?.default_cc_plan_amount)
        setFormData((prevData) => ({
          ...prevData,
          defaultCCPlanAmount: userDetails?.payload?.data?.default_cc_plan_amount,
        }));
      }
    }
    fetchuser()
  }, [RenderComponent == "ProductSelection"])




  const isCurrentOrFutureDate = (dateString) => {
    const givenDate = new Date(dateString);

    // Get the current date in IST
    const now = new Date();
    const istNow = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

    // Set both dates to midnight for accurate date-only comparison
    givenDate.setHours(0, 0, 0, 0);
    istNow.setHours(0, 0, 0, 0);

    return givenDate >= istNow;
  };


  //   const isCurrentOrFutureDate = (dateString) => {
  //   const givenDate = new Date(dateString);

  //   const now = new Date();
  //   const istNow = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

  //   // Set both dates to midnight for accurate date-only comparison
  //   givenDate.setHours(0, 0, 0, 0);
  //   istNow.setHours(0, 0, 0, 0);

  //   // Calculate the difference in milliseconds
  //   const diffInMs = givenDate - istNow;

  //   // Negative means past, greater than 7 days means too far
  //   const sevenDaysInMs = 25 * 24 * 60 * 60 * 1000;

  //   return diffInMs >= 0 && diffInMs <= sevenDaysInMs;
  // };


  const nomineeRelationList = [
    { label: "Husband", value: "Husband" },
    { label: "Wife", value: "Wife" },
    { label: "Spouse", value: "Spouse" },
    { label: "Father", value: "Father" },
    { label: "Mother", value: "Mother" },
    { label: "Son", value: "Son" },
    { label: "Daughter", value: "Daughter" },
    { label: "Brother", value: "Brother" },
    { label: "Sister", value: "Sister" },
    { label: "Grandfather", value: "Grandfather" },
    { label: "Grandmother", value: "Grandmother" },
    { label: "Grandson", value: "Grandson" },
    { label: "Granddaughter", value: "Granddaughter" },
    { label: "Uncle", value: "Uncle" },
    { label: "Aunt", value: "Aunt" },
    { label: "Others", value: "Others" },

  ];

  function isValidRelation(apiValue) {
    const checkValue = String(apiValue).toLowerCase(); // normalize

    return nomineeRelationList.some(item =>
      item.value.toLowerCase() === checkValue
    );
  }

  const getMakeList = (type) => {
    const masterList = {
      "Private car": [
        { value: "AUDI", label: "AUDI" },
        { value: "BMW", label: "BMW" },
        { value: "BYD", label: "BYD" },
        { value: "CHEVROLET", label: "CHEVROLET" },
        { value: "DATSUN", label: "DATSUN" },
        { value: "FIAT", label: "FIAT" },
        { value: "FORCE MOTORS", label: "FORCE MOTORS" },
        { value: "FORD", label: "FORD" },
        { value: "HONDA", label: "HONDA" },
        { value: "HYUNDAI", label: "HYUNDAI" },
        { value: "ISUZU", label: "ISUZU" },
        { value: "JAGUAR", label: "JAGUAR" },
        { value: "JEEP", label: "JEEP" },
        { value: "KIA", label: "KIA" },
        { value: "LAND ROVER", label: "LAND ROVER" },
        { value: "MAHINDRA", label: "MAHINDRA" },
        { value: "MARUTI SUZUKI", label: "MARUTI SUZUKI" },
        { value: "MERCEDES BENZ", label: "MERCEDES BENZ" },
        { value: "MG MOTOR", label: "MG MOTOR" },
        { value: "NISSAN", label: "NISSAN" },
        { value: "RENAULT", label: "RENAULT" },
        { value: "SKODA", label: "SKODA" },
        { value: "TATA", label: "TATA" },
        { value: "TOYOTA", label: "TOYOTA" },
        { value: "VOLKSWAGEN", label: "VOLKSWAGEN" },
        { value: "VOLVO", label: "VOLVO" },
        { value: "CITROEN", label: "CITROEN" },
        { value: "LEXUS", label: "LEXUS" },
        { value: "MINI", label: "MINI" },
        { value: "MITSUBISHI", label: "MITSUBISHI" },
        { value: "OTHER", label: "OTHER" },
      ],
      "Two Wheeler": [
        { value: "AMO MOBILITY", label: "AMO MOBILITY" },
        { value: "AMPERE", label: "AMPERE" },
        { value: "ASTAR", label: "ASTAR" },
        { value: "ATHER ENERGY", label: "ATHER ENERGY" },
        { value: "AVERA ELECTRIC VEHICLE", label: "AVERA ELECTRIC VEHICLE" },
        { value: "BAJAJ", label: "BAJAJ" },
        { value: "E ASHWA AUTOMOTIVE PVT LTD", label: "E ASHWA AUTOMOTIVE PVT LTD" },
        { value: "E CARBON NEUTRALITY", label: "E CARBON NEUTRALITY" },
        { value: "EVOLET", label: "EVOLET" },
        { value: "GRAVITY", label: "GRAVITY" },
        { value: "HARLEY DAVIDSON", label: "HARLEY DAVIDSON" },
        { value: "HONDA", label: "HONDA" },
        { value: "HERO", label: "HERO" },
        { value: "HERO MOTOCORP", label: "HERO MOTOCORP" },
        { value: "JAWA MOTORCYCLE", label: "JAWA MOTORCYCLE" },
        { value: "KTM", label: "KTM" },
        { value: "KVHIND AUTOMOTIVE PVT LTD", label: "KVHIND AUTOMOTIVE PVT LTD" },
        { value: "LECTRIX EV PVT LTD", label: "LECTRIX EV PVT LTD" },
        { value: "MR E BIKE", label: "MR E BIKE" },
        { value: "OKAYA", label: "OKAYA" },
        { value: "OLA ELECTRIC", label: "OLA ELECTRIC" },
        { value: "PIAGGIO", label: "PIAGGIO" },
        { value: "PURE ELECTRIC VEHICLES", label: "PURE ELECTRIC VEHICLES" },
        { value: "REVOLT", label: "REVOLT" },
        { value: "ROYAL ENFIELD", label: "ROYAL ENFIELD" },
        { value: "SUZUKI", label: "SUZUKI" },
        { value: "TRIUMPH", label: "TRIUMPH" },
        { value: "TVS", label: "TVS" },
        { value: "ULTRAVIOLETTE", label: "ULTRAVIOLETTE" },
        { value: "UM GLOBAL", label: "UM GLOBAL" },
        { value: "YAKUZA", label: "YAKUZA" },
        { value: "YAMAHA", label: "YAMAHA" },
        { value: "YEZDI", label: "YEZDI" },
        { value: "ZELO", label: "ZELO" },
        { value: "APRILIA", label: "APRILIA" },
        { value: "BENELLI", label: "BENELLI" },
        { value: "BMW MOTORRAD", label: "BMW MOTORRAD" },
        { value: "DUCATI", label: "DUCATI" },
        { value: "KAWASAKI", label: "KAWASAKI" },
        { value: "KEEWAY", label: "KEEWAY" },
        { value: "QJ MOTOR", label: "QJ MOTOR" },
        { value: "VESPA", label: "VESPA" },
        { value: "VIDA", label: "VIDA" },
        { value: "OBEN ELECTRIC", label: "OBEN ELECTRIC" },
        { value: "SIMPLE ENERGY", label: "SIMPLE ENERGY" },
        { value: "RIVER", label: "RIVER" },
        { value: "HOP ELECTRIC", label: "HOP ELECTRIC" },
        { value: "TORK MOTORS", label: "TORK MOTORS" },
        { value: "OTHER", label: "OTHER" },
      ],
      "PCV": [
        { value: "ALTIER ELECTRIC ", "label": "ALTIER ELECTRIC" },
        { value: "ASHOK LEYLAND", label: "ASHOK LEYLAND" },
        { value: "BYD", label: "BYD" },
        { value: "EICHER", label: "EICHER" },
        { value: "EULER", label: "EULER" },
        { value: "FORCE MOTORS", label: "FORCE MOTORS" },
        { value: "HYUNDAI", label: "HYUNDAI" },
        { value: "ISUZU", label: "ISUZU" },
        { value: "JSA", label: "JSA" },
        { value: "EKA", label: "EKA" },
        { value: "MAHINDRA", label: "MAHINDRA" },
        { value: "MARUTI SUZUKI", label: "MARUTI SUZUKI" },
        { value: "MINI METRO", label: "MINI METRO" },
        { value: "SML ISUZU", label: "SML ISUZU" },
        { value: "TATA", label: "TATA" },
        { value: "TOYOTA", label: "TOYOTA" },
        { value: "TVS", label: "TVS" },
        { value: "VOLVO", label: "VOLVO" }, { value: "BHARATBENZ", label: "BHARATBENZ" },
        { value: "JBM", label: "JBM" },
        { value: "OLECTRA", label: "OLECTRA" },
        { value: "SCANIA", label: "SCANIA" },
        { value: "RAJHANS E RICKSHAW", "label": "RAJHANS E RICKSHAW" },
        { value: "RENAULT COMMERCIAL", label: "RENAULT COMMERCIAL" },
        { value: "NRJ ELECTRIC VEHICLES", "label": "NRJ ELECTRIC VEHICLES" },
        { value: "FORCE MOTORS", "label": "FORCE MOTORS" },
        { value: "MAHINDRA ELECTRIC", "label": "MAHINDRA ELECTRIC" },
        { value: "YATRI E RICKSHAW", "label": "YATRI E RICKSHAW" },
        { value: "MAYURI E RICKSHAW", "label": "MAYURI E RICKSHAW" },
        { value: "OTHER", label: "OTHER" },
      ],
      "PCV-3W": [
        { value: "ATUL AUTO", label: "ATUL AUTO" },
        { value: "ALTIER ELECTRIC ", "label": "ALTIER ELECTRIC" },
        { value: "BAJAJ", label: "BAJAJ" },
        { value: "BHM", label: "BHM" },
        { value: " BRIGHT AUTO ZONE", label: " BRIGHT AUTO ZONE" },
        { value: "CHAMPION POLY PLAST", label: "CHAMPION POLY PLAST" },
        { value: "CYBER", label: "CYBER" },
        { value: "E ASHWA", label: "E ASHWA" },
        { value: "EKA", label: "EKA" },
        { value: "ENERGY ELECTRIC", label: "ENERGY ELECTRIC" },
        { value: "EULER", label: "EULER" },
        { value: "JAGUAR", label: "JAGUAR" },
        { value: "JSA", label: "JSA" },
        { value: "KINETIC GREEN", label: "KINETIC GREEN" },
        { value: "LOHIA AUTO", label: "LOHIA AUTO" },
        { value: "MAHINDRA ELECTRIC", label: "MAHINDRA ELECTRIC" },
        { value: "MAHINDRA", label: "MAHINDRA" },
        { value: "MAYURI E RICKSHAW", label: "MAYURI E RICKSHAW" },
        { value: "MINI METRO", label: "MINI METRO" },
        { value: "MONTRA", label: "MONTRA" },
        { value: "MODLINE ASSOCIATES PVT LTD", label: "MODLINE ASSOCIATES PVT LTD" },
        { value: "PIAGGIO", label: "PIAGGIO" },
        { value: "SAERA ELECTRIC", label: "SAERA ELECTRIC" },
        { value: "TI CLEAN MOBILITY", label: "TI CLEAN MOBILITY" },
        { value: "TVS", label: "TVS" },
        { value: "YATRI", label: "YATRI" },
        { value: "Shri Ram", label: "Shri Ram" },
        { value: "Autotech Pvt. Ltd", label: "Autotech Pvt. Ltd" },
        { value: "JANGID", label: "JANGID" },
        { value: "ADVANCE", label: "ADVANCE" },
        { value: "E RICKSHAW", label: "E RICKSHAW" },
        { value: "OMEGA SEIKI", label: "OMEGA SEIKI" },
        { value: "YC ELECTRIC", label: "YC ELECTRIC" },
        { value: "RAJHANS E RICKSHAW", "label": "RAJHANS E RICKSHAW" },
        { value: "NRJ ELECTRIC VEHICLES", "label": "NRJ ELECTRIC VEHICLES" },
        { value: "FORCE MOTORS", "label": "FORCE MOTORS" },
        { value: "MAHINDRA ELECTRIC", "label": "MAHINDRA ELECTRIC" },
        { value: "YATRI E RICKSHAW", "label": "YATRI E RICKSHAW" },
        { value: "MAYURI E RICKSHAW", "label": "MAYURI E RICKSHAW" },
        { value: "OTHER", label: "OTHER" },
      ],
      "GCV": [
        { value: "AMW", label: "AMW" },
        { value: "ALTIER ELECTRIC ", "label": "ALTIER ELECTRIC" },
        { value: "ASHOK LEYLAND", label: "ASHOK LEYLAND" },
        { value: "BHARATBENZ", label: "BHARATBENZ" },
        { value: "EICHER", label: "EICHER" },
        { value: "EULER", label: "EULER" },
        { value: "FORCE MOTORS", label: "FORCE MOTORS" },
        { value: "ISUZU", label: "ISUZU" },
        { value: "EKA", label: "EKA" },
        { value: "MAHINDRA", label: "MAHINDRA" },
        { value: "MARUTI SUZUKI", label: "MARUTI SUZUKI" },
        { value: "SML ISUZU", label: "SML ISUZU" },
        { value: "TATA", label: "TATA" },
        { value: "VOLVO COAL TRUCKS", label: "VOLVO COAL TRUCKS" },
        { value: "SCANIA", label: "SCANIA" },
        { value: "MAN", label: "MAN" },
        { value: "RAJHANS E RICKSHAW", "label": "RAJHANS E RICKSHAW" },
        { value: "NRJ ELECTRIC VEHICLES", "label": "NRJ ELECTRIC VEHICLES" },
        { value: "FORCE MOTORS", "label": "FORCE MOTORS" },
        { value: "MAHINDRA ELECTRIC", "label": "MAHINDRA ELECTRIC" },
        { value: "YATRI E RICKSHAW", "label": "YATRI E RICKSHAW" },
        { value: "MAYURI E RICKSHAW", "label": "MAYURI E RICKSHAW" },
        { value: "OTHER", label: "OTHER" }
      ],
      "GCV-3W": [
        { value: "ALTIGREEN", label: "ALTIGREEN" },
        { value: "ALTIER ELECTRIC ", "label": "ALTIER ELECTRIC" },
        { value: "ATUL AUTO", label: "ATUL AUTO" },
        { value: "BAJAJ AUTO", label: "BAJAJ AUTO" },
        { value: " BRIGHT AUTO ZONE", label: " BRIGHT AUTO ZONE" },
        { value: "EUCLID", label: "EUCLID" },
        { value: "EULER", label: "EULER" },
        { value: "EKA", label: "EKA" },
        { value: "KINETIC GREEN", label: "KINETIC GREEN" },
        { value: "LOHIA AUTO", label: "LOHIA AUTO" },
        { value: "MAHINDRA", label: "MAHINDRA" },
        { value: "OSM MONTY", label: "OSM MONTY" },
        { value: "JSA", label: "JSA" },
        { value: "PIAGGIO Ape", label: "PIAGGIO Ape" },
        { value: "MONTRA", label: "MONTRA" },
        { value: "TVS", label: "TVS" },
        { value: "OMEGA SEIKI", label: "OMEGA SEIKI" },
        { value: "RAJHANS E RICKSHAW", "label": "RAJHANS E RICKSHAW" },
        { value: "NRJ ELECTRIC VEHICLES", "label": "NRJ ELECTRIC VEHICLES" },
        { value: "FORCE MOTORS", "label": "FORCE MOTORS" },
        { value: "MAHINDRA ELECTRIC", "label": "MAHINDRA ELECTRIC" },
        { value: "YATRI E RICKSHAW", "label": "YATRI E RICKSHAW" },
        { value: "MAYURI E RICKSHAW", "label": "MAYURI E RICKSHAW" }
      ],
      "MISC-D": [
        { value: "ACE", label: "ACE" },
        { value: "ALTIER ELECTRIC ", "label": "ALTIER ELECTRIC" },
        { value: "CASE", label: "CASE" },
        { value: "CATERPILLAR", label: "CATERPILLAR" },
        { value: "ESCORTS TRAC", label: "ESCORTS TRAC" },
        { value: "FORCE TRACTORS", label: "FORCE TRACTORS" },
        { value: "HMT", label: "HMT" },
        { value: "JCB", label: "JCB" },
        { value: "JOHN DEERE", label: "JOHN DEERE" },
        { value: "KUBOTA", label: "KUBOTA" },
        { value: "MAHINDRA TRACTORS", label: "MAHINDRA TRACTORS" },
        { value: "MASSEY FERGUSON", label: "MASSEY FERGUSON" },
        { value: "NEW HOLLAND", label: "NEW HOLLAND" },
        { value: "POWERTRACTOR", label: "POWERTRACTOR" },
        { value: "SONALIKA", label: "SONALIKA" },
        { value: "Swaraj", label: "Swaraj" },
        { value: "TAFE", label: "TAFE" },
        { value: "V ST Tillers", label: "V ST Tillers" },
        { value: "PREET", label: "PREET" },
        { value: "INDO FARM", label: "INDO FARM" },
        { value: "CAPTAIN", label: "CAPTAIN" },
        { value: "SOLIS", label: "SOLIS" },
        { value: "RAJHANS E RICKSHAW", "label": "RAJHANS E RICKSHAW" },
        { value: "NRJ ELECTRIC VEHICLES", "label": "NRJ ELECTRIC VEHICLES" },
        { value: "FORCE MOTORS", "label": "FORCE MOTORS" },
        { value: "MAHINDRA ELECTRIC", "label": "MAHINDRA ELECTRIC" },
        { value: "YATRI E RICKSHAW", "label": "YATRI E RICKSHAW" },
        { value: "MAYURI E RICKSHAW", "label": "MAYURI E RICKSHAW" },
        { value: "OTHER", label: "OTHER" }
      ],
      
    };

    // Safe check to handle trailing spaces or unexpected case variations
    const cleanType = type?.trim();
    return masterList[cleanType] || [];
  };
  const findMatchingMake = (pdfMake, vehicleType) => {

    if (!pdfMake || !vehicleType) return null;

    // 1. Get the list strictly for this vehicle type
    const existingList = getMakeList(vehicleType);
    if (!existingList.length) return null;

    // 2. Clean the PDF string (lowercase and remove all spaces/special chars)
    const cleanPdf = pdfMake.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!cleanPdf) return null;

    // 3. Look for a similar match in the list
    const match = existingList.find(item => {
      // Clean the dropdown value/label the exact same way
      const cleanValue = item.value.toLowerCase().replace(/[^a-z0-9]/g, '');
      const cleanLabel = item.label.toLowerCase().replace(/[^a-z0-9]/g, '');

      // Check if either one includes the other (handles "CATERP" matching "CATERPILLAR")
      return (
        cleanValue.includes(cleanPdf) ||
        cleanPdf.includes(cleanValue) ||
        cleanLabel.includes(cleanPdf) ||
        cleanPdf.includes(cleanLabel)
      );
    });

    // 4. Return the dropdown object if matched, else null
    return match || null;
  };
  
  useEffect(() => {
    let CheckCurData = isCurrentOrFutureDate(pdfReaderData?.data?.data?.policy_start_date)
    const pdfMake = pdfReaderData?.data?.data?.make;
    const currentVehicleType = FormData.vehicleType;
    const matchedMakeObject = findMatchingMake(pdfMake, currentVehicleType);

    console.log("Matched Make Object:", matchedMakeObject);
    setFormData((prevItems) => ({
      ...prevItems,
      addressLineOne: pdfReaderData?.data?.data?.addressLineOne !== "null" && pdfReaderData?.data?.data?.addressLineOne ? pdfReaderData?.data?.data?.addressLineOne : "",
      addressLineTwo: pdfReaderData?.data?.data?.addressLineTwo !== "null" && pdfReaderData?.data?.data?.addressLineTwo ? pdfReaderData?.data?.data?.addressLineTwo : "",
      chassisNumber: pdfReaderData?.data?.data?.chassisNumber !== "null" && pdfReaderData?.data?.data?.chassisNumber ? pdfReaderData?.data?.data?.chassisNumber : "",
      city: pdfReaderData?.data?.data?.city !== "null" && pdfReaderData?.data?.data?.city ? pdfReaderData?.data?.data?.city : "",
      companyName: pdfReaderData?.data?.data?.companyName !== "null" && pdfReaderData?.data?.data?.companyName ? pdfReaderData?.data?.data?.companyName : "",
      dob: pdfReaderData?.data?.data?.dob !== "null" && pdfReaderData?.data?.data?.city ? pdfReaderData?.data?.data?.dob : "",
      emailId: pdfReaderData?.data?.data?.emailId !== "null" && pdfReaderData?.data?.data?.emailId ? pdfReaderData?.data?.data?.emailId : "",
      engineNumber: pdfReaderData?.data?.data?.engineNumber !== "null" && pdfReaderData?.data?.data?.engineNumber ? pdfReaderData?.data?.data?.engineNumber : "",
      firstName: pdfReaderData?.data?.data?.firstName !== "null" && pdfReaderData?.data?.data?.firstName ? pdfReaderData?.data?.data?.firstName : "",
      gender: pdfReaderData?.data?.data?.gender !== "null" && pdfReaderData?.data?.data?.gender ? pdfReaderData?.data?.data?.gender : "",
      lastName: pdfReaderData?.data?.data?.lastName !== "null" && pdfReaderData?.data?.data?.lastName ? pdfReaderData?.data?.data?.lastName : "",
      make: matchedMakeObject ? matchedMakeObject?.value : null,
      mobileNumber: pdfReaderData?.data?.data?.mobileNumber !== "null" && pdfReaderData?.data?.data?.mobileNumber ? pdfReaderData?.data?.data?.mobileNumber : "",
      model: pdfReaderData?.data?.data?.model !== "null" && pdfReaderData?.data?.data?.model ? pdfReaderData?.data?.data?.model : "",
      nomineeAge: pdfReaderData?.data?.data?.nomineeAge !== "null" && pdfReaderData?.data?.data?.nomineeAge ? pdfReaderData?.data?.data?.nomineeAge : "",
      nomineeName: pdfReaderData?.data?.data?.nomineeName !== "null" && pdfReaderData?.data?.data?.nomineeName ? pdfReaderData?.data?.data?.nomineeName : "",
      nomineeRelation: pdfReaderData?.data?.data?.nomineeRelation !== "null" && isValidRelation(pdfReaderData?.data?.data?.nomineeRelation) ? pdfReaderData?.data?.data?.nomineeRelation : "",
      pincode: pdfReaderData?.data?.data?.pincode !== "null" && pdfReaderData?.data?.data?.pincode ? pdfReaderData?.data?.data?.pincode : "",
      policyNumber: pdfReaderData?.data?.data?.policyNumber !== "null" && pdfReaderData?.data?.data?.policyNumber ? pdfReaderData?.data?.data?.policyNumber : "",
      state: pdfReaderData?.data?.data?.state !== "null" && pdfReaderData?.data?.data?.state ? pdfReaderData?.data?.data?.state : "",
      // policyStartDate: CheckCurData ? pdfReaderData?.data?.data?.policy_start_date : "",
    }));

  }, [pdfReaderData])

  // VALIDATION FOR ALTERNATE FORMS

  const validateVehicleDetails = () => {
    const newErrors = {};

    if (!FormData.businessType) {
      newErrors.businessType = "Business Type is required";
    }

    if (!FormData.vehicleNumber && FormData.businessType != "New") {
      newErrors.vehicleNumber = "Vehicle number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateMmvDetails = () => {
    const newErrors = {};
    if (!FormData.make) {
      newErrors.make = "Vehicle Brand is required";
    }

    if (!FormData.model) {
      newErrors.model = "Vehicle Model is required";
    }

    if (!FormData.engineNumber) {
      newErrors.engineNumber = "Engine Number is required";
    }

    if (!FormData.chassisNumber) {
      newErrors.chassisNumber = "Chassis Number is required";
    }

    if (!FormData.planBuyPrice) {
      newErrors.planBuyPrice = "Plan Price is required";
    }
    if (!FormData.policyNumber) {
      newErrors.policyNumber = "Policy Number is required";
    }


    let valueprice = getLoggedInStatus?.data?.loginData?.mobile == "7303350087" ? 599 : Number(FormData.minProductPrice)
    if (
      FormData.planBuyPrice
      && (Number(FormData.planBuyPrice) < valueprice ||
        Number(FormData.planBuyPrice) > FormData.maxProductPrice)
    ) {
      newErrors.planBuyPrice = `Range of Plan Price should be between ${valueprice} - ${FormData.maxProductPrice}`;
    }

    if (
      FormData.planBuyPrice
      && (Number(FormData.planBuyPrice) > FormData.minProductPrice &&
        Number(FormData.planBuyPrice) < FormData.maxProductPrice)
    ) {
      if ((Number(FormData.planBuyPrice) < FormData.minPlanAmount)) {
        newErrors.planBuyPrice = `Plan Price should be greater than ${FormData.minPlanAmount}`;
      }
    }

    if (!FormData.masterPolicyNumber) {
      newErrors.masterPolicyNumber = "Master policy number is required";
    }

    if (!FormData.policyStartDate) {
      newErrors.policyStartDate = "Policy Start date is required";
    }

    if (!FormData.companyName) {
      newErrors.companyName = "Company Name is required";
    }

    if (!FormData.vehicleType) {
      newErrors.vehicleType = "Vehicle Type is required";
    }
    if (!FormData.tenurePa && RsaOnly == 0) {
      newErrors.tenurePa = "CPA tenure is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePersonalDetails = () => {
    const newErrors = {};

    if (!FormData.firstName) {
      newErrors.firstName = "First Name is required";
    }
    if (!FormData.mobileNumber) {
      newErrors.mobileNumber = "Mobile Number is required";
    }
    let regexMobile = /^[2-9]{1}[0-9]{9}$/;

    if (FormData.mobileNumber && !regexMobile.test(FormData.mobileNumber)) {
      newErrors.mobileNumber = "Mobile number is Invalid";
    }

    if (!FormData.gender && RsaOnly == 0) {
      newErrors.gender = "Gender is required";
    }

    if (!FormData.nomineeAge && RsaOnly == 0) {
      newErrors.nomineeAge = "Age is required";
    }
    if (FormData.nomineeAge == 0 && RsaOnly == 0) {
      newErrors.nomineeAge = "Age is not Valid";
    }

    if (!FormData.dob && RsaOnly == 0) {
      newErrors.dob = "Date of Birth is required";
    }
    let gstValidate = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (FormData.gstNumber && !gstValidate.test(FormData.gstNumber)) {
      newErrors.gstNumber = "Please enter valid GST Number."
    }

    // if (FormData.dob) {
    //   var userDOB = new Date(FormData.dob);
    //   var currentDate = new Date();
    //   var age = currentDate.getFullYear() - userDOB.getFullYear();

    //   if (
    //     currentDate.getMonth() < userDOB.getMonth() ||
    //     (currentDate.getMonth() === userDOB.getMonth() &&
    //       currentDate.getDate() < userDOB.getDate())
    //   ) {
    //     age--;
    //   }

    //   if (age < 18) {
    //     newErrors.dob = "You must be 18+ to proceed further";
    //   }

    //   if (age > 70) {
    //     newErrors.dob = "You must be below 70 years of age to proceed further";
    //   }
    // }
    if (FormData.dob) {
      var userDOB = new Date(FormData.dob);
      var currentDate = new Date();

      // Calculate the differences
      var years = currentDate.getFullYear() - userDOB.getFullYear();
      var months = currentDate.getMonth() - userDOB.getMonth();
      var days = currentDate.getDate() - userDOB.getDate();

      // Adjust for negative days
      if (days < 0) {
        months--;
        var previousMonth = currentDate.getMonth() - 1;
        if (previousMonth < 0) {
          previousMonth = 11;
        }
        var daysInPreviousMonth = new Date(
          currentDate.getFullYear(),
          previousMonth + 1,
          0
        ).getDate();
        days += daysInPreviousMonth;
      }
      if (months < 0) {
        years--;
        months += 12;
      }
      // console.log(years,months,days,"daysdays")
      // || (years === 18 && (months > 0 || days > 0))

      if ((years == 18 && (days == 0 && months == 0) || years < 18)) {
        newErrors.dob = "You must be 18+ to proceed further";
      } else if (years > 70 || (years === 70 && (months > 0 || days > 0))) {
        newErrors.dob = "You must be below 70 years of age to proceed further";
      }
    }

    if (!FormData.nomineeName && RsaOnly == 0) {
      newErrors.nomineeName = "Nominee Name is required";
    }
    if (!FormData.lastName && RsaOnly == 0) {
      newErrors.lastName = "Last Name is required";
    }
    if (!FormData.emailId) {
      newErrors.emailId = "Email ID is required";
    }
    let regexEmail = /^\S+@\S+\.\S+$/;
    if (FormData.emailId && !regexEmail.test(FormData.emailId)) {
      newErrors.emailId = "Email is Invalid";
    }
    if (!FormData.nomineeRelation && RsaOnly == 0) {
      newErrors.nomineeRelation = "Nominee Relation is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateAddressDetails = () => {
    const newErrors = {};

    if (!FormData.addressLineOne) {
      newErrors.addressLineOne = "Address Line 1 is required";
    }
    if (!FormData.state) {
      newErrors.state = "State is required";
    }
    if (!FormData.pincode) {
      newErrors.pincode = "Pincode is required";
    }

    let pinregEx = /^[1-9]{1}[0-9]{2}[0-9]{3}$/;
    if (FormData.pincode && !pinregEx.test(FormData.pincode)) {
      newErrors.pincode = "Invalid pin code";
    }

    if (!FormData.addressLineTwo) {
      newErrors.addressLineTwo = "Address Line 2 is required";
    }

    if (!FormData.city) {
      newErrors.city = "City is required";
    }

    if (FormData.isCompleteCareChecked === true && !isUserDefaultCcPlanAmt) {
      if (!FormData.cc) {
        newErrors.cc = "CC is required";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // HANDLER TO UPDATE THE FORM-DATA
  const HanldeFormData = (e, constantName) => {

    const { name, value, checked } = e?.target || {};
    if (name) {
      delete errors[name]
    }

    if (constantName === "productName") {
      setFormData((prevData) => ({
        ...prevData,
        productName: e.name,
        productId: e.id,
        minProductPrice: e.min_selling_price,
        maxProductPrice: e.max_selling_price,
        masterPolicyNumber: e.master_policy_no
      }));
      if (e) {
        setRenderComponent("SelectVehicleType");
      }
    } else if (name === "businessType") {
      if (value === "New") {
        dispatch(resetVehicleData());
        setFormData((prevData) => ({
          ...prevData,
          vehicleNumber: null,
          tenurePa: (FormData.vehicleType == "Two Wheeler" && value == "New") || (FormData.vehicleType == "Private car" && value == "New") ? null : 1

        }));
      }
      setFormData((prevData) => ({
        ...prevData,
        businessType: value,
        tenurePa: (FormData.vehicleType == "Two Wheeler" && value == "New") || (FormData.vehicleType == "Private car" && value == "New") ? null : 1
      }));




    } else if (constantName === "resetData") {
      setFormData((prevData) => ({
        ...prevData,
        vehicleNumber: null,
        businessType: null,
        make: null,
        companyName: null,
        model: null,
        firstName: null,
        lastName: null,
        mobileNumber: null,
        emailId: null,
        pincode: null,
        planBuyPrice: null,
        policyBuyPrice: null,
        policyStartDate: null,
        nomineeName: null,
        nomineeRelation: null,
        masterPolicyNumber: null,
        engineNumber: null,
        chassisNumber: null,
        addressLineOne: null,
        addressLineTwo: null,
        state: null,
        city: null,
        dob: null,
        gender: null,
        nomineeAge: null,
        vehicleType: null
      }));
    } else if (name === "mobileNumber") {
      if (value.length <= 10) {
        setFormData((prevItems) => ({
          ...prevItems,
          mobileNumber: value,
        }));
      }
    } else if (name === "model") {
      if (value.length <= 50) {
        setFormData((prevItems) => ({
          ...prevItems,
          model: value,
        }));
      }
    }

    else if (name === "pincode") {
      if (value.length <= 6) {
        setFormData((prevItems) => ({
          ...prevItems,
          pincode: value,
        }));
      }
    } else if (constantName === "vehicleType") {
      setRenderComponent("carDetails");
      setFormData((prevItems) => ({
        ...prevItems,
        vehicleType: e?.type,
        minPlanAmount: e?.minamount,
      }));
    } else if (name === "isCompleteCareChecked") {
      setFormData((prevItems) => ({
        ...prevItems,
        isCompleteCareChecked: checked ? true : false,
      }))
      if (checked === false) {
        setFormData((prevItems) => ({
          ...prevItems,
          cc: "",
        }))
      }
    } else if (name == "nomineeAge") {
      if (value <= 100) {
        setFormData((prevItems) => ({
          ...prevItems,
          nomineeAge: value,
        }));
      }
    }
    else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: name === "policyStartDate" || name === "dob" ? value : value.toUpperCase(),
      }));
    }
  };

  async function EngineValidation(data2) {
    setCheckEngineLoader(true)
    let response = await dispatch(fectchEngineValidaionAction({
      data: data2
    }))
    return response

  }
  // PAGE REVEAL FUNCTIONS
  const setComponentToRender = (componentName) => {

    setCallForEdit(false);
    switch (componentName) {
      case "navbar":
        setRenderComponent("ProductSelection");
        break;

      case "cardetails":
        const isValidVehicleDetails = validateVehicleDetails();
        if (FormData.businessType != "New") {
          if (isValidVehicleDetails) {
            dispatch(fetchMmvAction(FormData.vehicleNumber));
            if (!loading) {
              setRenderComponent("editCarDetails");
            }
          }
        } else {
          setRenderComponent("editCarDetails");
        }
        break;

      case "editCarDetails":
        const isValidMmvDetails = validateMmvDetails();
        let data = {
          engine: FormData?.engineNumber,
          chassisNumber: FormData?.chassisNumber,
          newActiveDate: FormData?.policyStartDate
        }
        if (isValidMmvDetails) {

          EngineValidation(data).then((values) => {
            if (values?.payload?.data?.chassis || values?.payload?.data?.engine) {
              const newErrors = {};
              if (values?.payload?.data?.chassis) {
                newErrors.chassisNumber = values?.payload?.data?.msgOne || "chassis Number is alreay exist"
              }
              if (values?.payload?.data?.engine) {
                newErrors.engineNumber = values?.payload?.data?.msgTwo || "Engine Number is alreay exist"
              }
              setCheckEngineLoader(false)
              setErrors(newErrors);
              return Object.keys(newErrors).length === 0;
            } else if (values?.payload?.data?.chassis == false && values?.payload?.data?.engine == false) {
              setRenderComponent("editPersonalDetails");
              setCheckEngineLoader(false)
            }
          }).catch((errors) => {
            console.log(errors, "errors")

            setCheckEngineLoader(false)
          })

        }
        break;

      case "editPersonalDetails":
        const isValid = validatePersonalDetails();
        if (isValid) {
          setRenderComponent("editAdressDetails");
        }
        break;

      case "editAddressDetails":
        const isValidAddress = validateAddressDetails();
        if (isValidAddress) {
          openModal();
        }
        break;

      case "prevPolicyDetails":
        setRenderComponent("editPersonalDetails");
        break;

      default:
        break;
    }
  };

  // BACK BTN FUN
  const handleBackBtn = (componentName) => {
    // alert(componentName);
    setCallForEdit(false);
    switch (componentName) {

      case "SelectVehicleType":
        setRenderComponent("ProductSelection");
        break;

      case "cardetails":
        setRenderComponent("SelectVehicleType");
        break;

      case "editCarDetails":
        setRenderComponent("carDetails");
        break;

      case "prevPolicyDetails":
        setRenderComponent("editCarDetails");
        break;

      case "editPersonalDetails":
        setRenderComponent("editCarDetails");
        break;

      case "editAddressDetails":
        setRenderComponent("editPersonalDetails");
        break;

      case "downloadPolicy":
        setRenderComponent("editAdressDetails");
        break;

      case "dropToProductPage":
        setRenderComponent("productPage");
        break;

      default:
        break;
    }
  };

  const handleEditTriggers = (componentName) => {
    if (componentName === "editCarDetails") {
      setRenderComponent("editCarDetails");
      setCallForEdit(true);
    } else if (componentName === "prevPolicyDetails") {
      setRenderComponent("prevPolicyDetails");
      setCallForEdit(true);
    } else {
      setRenderComponent("editPersonalDetails");
      setCallForEdit(true);
    }
  };

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  //Fix one day back date
  // {...FormData,dob:getFormatedDate(FormData?.dob),policyStartDate:getFormatedDate(FormData?.policyStartDate)},
  const getFormatedDate = ((date) => {
    const localDate = new Date(date);
    const offsetDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
    const formattedDate = offsetDate.toISOString();
    return formattedDate
  })

  const paymentConfirmed = async () => {
    setisButtonLoader(true);

    let dispatchPurchase = await dispatch(
      purchaseAction({
        data: {
          data: {
            proposal: {
              ...FormData,
              dob: RsaOnly == 1 ? "2000-01-01" : FormData.dob,
              gender: RsaOnly == 1 ? "MALE" : FormData?.gender,
              nomineeName: RsaOnly == 1 ? "RSA_Only" : FormData?.nomineeName
            }
          },
        },
        userToken: userToken?.token,
      })
    );
    if (dispatchPurchase.payload.status === 1) {
      await dispatch(getWalletBalance(userToken?.token));
      setTimeout(() => {
        setisButtonLoader(false);
        setRenderComponent("downloadPolicy");
        closeModal();
      }, 2000);

    } else {
      setisButtonLoader(false);
      alert("Something Went Wrong!, Please try again.");
      closeModal();
    }
  };

  return (
    <>
      {loading === true ? <Loader /> : null}

      {/* payment confirmation modal */}

      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <PaymentConfirmation
            closeModal={closeModal}
            paymentConfirmed={paymentConfirmed}
            isLoading={getPurchaseDetails?.isLoading}
            isApiLoaded={isButtonLoader}

          />
        </Modal>
      </div>

      <Navbar
        component={
          <Button
            text="My Account"
            icons={user}
            className="btn-myAccount"
            classNameImg="img-circle"
            event={(e) => navigate("/My-Account")}
          />
        }
        setComponentToRender={setComponentToRender}
        HanldeFormData={HanldeFormData}
      />

      {/* SELECT PRODUCT */}

      {RenderComponent === "ProductSelection" && (
        <ProductSelection event={HanldeFormData} data={FormData} />
      )}

      {/* SELECT VEHICLE TYPE */}

      {RenderComponent === "SelectVehicleType" && (
        <VehicleType event={HanldeFormData} data={FormData} handleBackBtn={handleBackBtn} />
      )}

      {/* vehicleNumber */}

      {RenderComponent === "carDetails" && (
        <CarDetails
          FormData={FormData}
          HanldeFormData={HanldeFormData}
          setComponentToRender={setComponentToRender}
          handleBackBtn={handleBackBtn}
          chekEngineLodar={chekEngineLodar}
          errors={errors}
        />
      )}

      {/* EDIT-CAR-DETAILS */}

      {RenderComponent === "editCarDetails" && (
        <EditVehicleDetails
          FormData={FormData}
          getLoggedInStatus={getLoggedInStatus}
          setFormData={setFormData}
          HanldeFormData={HanldeFormData}
          setComponentToRender={setComponentToRender}
          handleBackBtn={handleBackBtn}
          CallForEdit={CallForEdit}
          errors={errors}
          chekEngineLodar={chekEngineLodar}
          getMakeList={getMakeList}
          RsaOnly={RsaOnly}
          userMobile={userToken?.mobile}
        />
      )}

      {/* EditPersonalDetails */}

      {RenderComponent === "editPersonalDetails" && (
        <EditPersonalDetails
          FormData={FormData}
          HanldeFormData={HanldeFormData}
          setComponentToRender={setComponentToRender}
          handleBackBtn={handleBackBtn}
          CallForEdit={CallForEdit}
          RsaOnly={RsaOnly}
          errors={errors}
        />
      )}

      {/* AddressDetails */}

      {RenderComponent === "editAdressDetails" && (
        <EditAddressDetails
          FormData={FormData}
          HanldeFormData={HanldeFormData}
          setFormData={setFormData}
          setComponentToRender={setComponentToRender}
          handleBackBtn={handleBackBtn}
          CallForEdit={CallForEdit}
          errors={errors}
        />
      )}

      {/* Download - PAGE */}

      {RenderComponent === "downloadPolicy" && (
        <DownloadPolicy
          FormData={FormData}
          HanldeFormData={HanldeFormData}
          setComponentToRender={setComponentToRender}
          handleBackBtn={handleBackBtn}
          handleEditTriggers={handleEditTriggers}
          policyNumber={getPurchaseDetails?.data?.data?.certificateNo}
        />
      )}
    </>
  );
};

export default ViewPlans;
